import { useState, useRef } from "react";
import { useNavigate } from "react-router-dom";
import { API_URL } from "../config";
const Toggle = ({ value, onChange }) => (
  <div
    onClick={() => onChange(!value)}
    style={{
      width: "44px", height: "24px", borderRadius: "12px",
      background: value ? "#2563EB" : "#D1D5DB",
      cursor: "pointer", position: "relative", flexShrink: 0,
      transition: "background 0.2s",
    }}
  >
    <div style={{
      position: "absolute", top: "3px",
      left: value ? "23px" : "3px",
      width: "18px", height: "18px", borderRadius: "50%",
      background: "#fff", transition: "left 0.2s",
      boxShadow: "0 1px 3px rgba(0,0,0,0.2)",
    }} />
  </div>
);

export default function Upload() {
  const navigate = useNavigate();
  const [dragOver, setDragOver] = useState(false);
  const [files, setFiles] = useState([]);
  const [encrypt, setEncrypt] = useState(true);
  const [pin, setPin] = useState(true);
  const [redundancy, setRedundancy] = useState("High (Multiple Nodes)");
  const fileInputRef = useRef();

  const handleDrop = (e) => {
    e.preventDefault();
    setDragOver(false);
    const dropped = Array.from(e.dataTransfer.files);
    if (dropped.length) setFiles(prev => [...prev, ...dropped]);
  };

  const handleBrowse = (e) => {
    const picked = Array.from(e.target.files);
    if (picked.length) setFiles(prev => [...prev, ...picked]);
    e.target.value = "";
  };

  const handleUpload = async () => {
  if (!files.length) {
    alert("Please select a file");
    return;
  }

  try {
    const formData = new FormData();

formData.append("file", files[0]);

formData.append(
  "owner_email",
  localStorage.getItem("email") || "test@gmail.com"
);

formData.append("encrypt", encrypt);
formData.append("pin", pin);
formData.append("redundancy", redundancy);

    const response = await fetch(`${API_URL}/api/secure-drive/upload`, {
        method: "POST",
        body: formData,
      }
    );

    const data = await response.json();

    console.log(data);

    if (data.success) {
      alert("File uploaded successfully!");
      setFiles([]);
      navigate("/file-details", { state: { file: {
        id: data.file_id,
        file_name: data.filename,
        cid: data.cid,
        ipfs_url: data.ipfs_url,
        file_size: files[0].size,
        file_type: files[0].type,
        owner_email: localStorage.getItem("email"),
        uploaded_at: new Date().toISOString(),
        encrypt,
        pin,
        redundancy
      }}});
    } else {
      alert("Upload failed");
    }
  } catch (error) {
    console.error(error);
    alert("Error uploading file");
  }
};

  return (
    <div style={{
      fontFamily: "'Inter','Segoe UI',sans-serif",
      background: "#ffffff", minHeight: "100vh",
      color: "#1A1D23", padding: "28px",
    }}>

      {/* Outer Upload Box */}
      <div style={{
        border: "1px solid #E5E7EB",
        borderRadius: "16px",
        background: "#FFFFFF",
        marginBottom: "28px",
        overflow: "hidden",
      }}>
        {/* Drop Zone */}
        <div
          onDragOver={e => { e.preventDefault(); setDragOver(true); }}
          onDragLeave={() => setDragOver(false)}
          onDrop={handleDrop}
          onClick={() => fileInputRef.current.click()}
          style={{
            border: `2px dashed ${dragOver ? "#2563EB" : "#CBD5E1"}`,
            borderRadius: "12px",
            padding: "48px 24px",
            textAlign: "center",
            cursor: "pointer",
            margin: "20px",
            background: dragOver ? "#EFF6FF" : "#FAFBFC",
            transition: "all 0.15s",
            boxSizing: "border-box",
          }}
        >
          <div style={{ marginBottom: "12px", display: "flex", justifyContent: "center" }}>
            <svg width="48" height="48" viewBox="0 0 24 24" fill="none" stroke="#2563EB" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round">
              <polyline points="16 16 12 12 8 16" />
              <line x1="12" y1="12" x2="12" y2="21" />
              <path d="M20.39 18.39A5 5 0 0018 9h-1.26A8 8 0 103 16.3" />
            </svg>
          </div>
          <p style={{ fontSize: "16px", fontWeight: 600, color: "#1E293B", margin: "0 0 4px" }}>
            Drag &amp; drop files here
          </p>
          <p style={{ fontSize: "14px", color: "#94A3B8", margin: "0 0 16px" }}>or</p>
          <button
            onClick={e => { e.stopPropagation(); fileInputRef.current.click(); }}
            style={{
              background: "#2563EB", color: "#fff", border: "none",
              borderRadius: "10px", padding: "0 24px", fontSize: "14px",
              fontWeight: 600, cursor: "pointer",
              height: "44px",
              fontFamily: "'Inter','Segoe UI',sans-serif",
            }}
            onMouseEnter={e => e.currentTarget.style.background = "#1D4ED8"}
            onMouseLeave={e => e.currentTarget.style.background = "#2563EB"}
          >
            Browse Files
          </button>
          <p style={{ fontSize: "14px", color: "#94A3B8", margin: "14px 0 0" }}>
            Files will be encrypted and stored on IPFS.
          </p>
          {files.length > 0 && (
            <div style={{ marginTop: "10px" }}>
              <p style={{ fontSize: "14px", color: "#2563EB", fontWeight: "600" }}>
                {files[0].name}
              </p>
              <p style={{ fontSize: "14px", color: "#64748B" }}>
                {(files[0].size / 1024).toFixed(2)} KB
              </p>
            </div>
          )}
          <input
            ref={fileInputRef}
            type="file"
            style={{ display: "none" }}
            onChange={handleBrowse}
          />
        </div>

        {/* Upload Options */}
        <div style={{ padding: "0 20px 20px 20px" }}>
          <p style={{ fontSize: "16px", fontWeight: 700, color: "#0F172A", margin: "0 0 16px", textAlign: "left" }}>
            Upload Options
          </p>

          <div style={{ display: "flex", flexDirection: "column" }}>
            {/* Encrypt */}
            <div style={{ display: "flex", alignItems: "center", gap: "12px", padding: "16px 0", borderBottom: "1px solid #F1F5F9" }}>
              <div>
                <svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="#2563EB" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round">
                  <rect x="3" y="11" width="18" height="11" rx="2" ry="2" />
                  <path d="M7 11V7a5 5 0 0110 0v4" />
                </svg>
              </div>
              <div style={{ flex: 1, textAlign: "left" }}>
                <p style={{ fontSize: "16px", fontWeight: 600, color: "#1E293B", margin: "0 0 2px" }}>Encrypt Before Upload</p>
                <p style={{ fontSize: "14px", color: "#94A3B8", margin: 0 }}>Encrypt files locally before uploading to IPFS.</p>
              </div>
              <Toggle value={encrypt} onChange={setEncrypt} />
            </div>

            {/* Pin */}
            <div style={{ display: "flex", alignItems: "center", gap: "12px", padding: "16px 0", borderBottom: "1px solid #F1F5F9" }}>
              <div>
                <svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="#2563EB" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round">
                  <path d="M12 2a7 7 0 017 7c0 5.25-7 13-7 13S5 14.25 5 9a7 7 0 017-7z" />
                  <circle cx="12" cy="9" r="2.5" />
                </svg>
              </div>
              <div style={{ flex: 1, textAlign: "left" }}>
                <p style={{ fontSize: "16px", fontWeight: 600, color: "#1E293B", margin: "0 0 2px" }}>Pin to IPFS Network</p>
                <p style={{ fontSize: "14px", color: "#94A3B8", margin: 0 }}>Pin the file to ensure it is always available.</p>
              </div>
              <Toggle value={pin} onChange={setPin} />
            </div>

            {/* Redundancy */}
            <div style={{ display: "flex", alignItems: "center", gap: "12px", padding: "16px 0" }}>
              <div>
                <svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="#2563EB" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round">
                  <circle cx="12" cy="12" r="3" />
                  <path d="M12 1v4M12 19v4M4.22 4.22l2.83 2.83M16.95 16.95l2.83 2.83M1 12h4M19 12h4M4.22 19.78l2.83-2.83M16.95 7.05l2.83-2.83" />
                </svg>
              </div>
              <div style={{ flex: 1, textAlign: "left" }}>
                <p style={{ fontSize: "16px", fontWeight: 600, color: "#1E293B", margin: "0 0 8px" }}>Redundancy</p>
                <select
                  value={redundancy}
                  onChange={e => setRedundancy(e.target.value)}
                  style={{
                    width: "100%", padding: "8px 12px", border: "1px solid #E5E7EB",
                    borderRadius: "7px", fontSize: "14px", color: "#374151",
                    background: "#fff", outline: "none", cursor: "pointer",
                  }}
                >
                  <option>High (Multiple Nodes)</option>
                  <option>Medium (2 Nodes)</option>
                  <option>Low (1 Node)</option>
                </select>
              </div>
            </div>
          </div>
        </div>
      </div>

      {/* Footer — Cancel left, Upload right */}
      <div style={{ display: "flex", justifyContent: "space-between", alignItems: "center" }}>
        <button
          onClick={() => navigate("/drive")}
          style={{
            background: "#fff", color: "#374151", border: "1px solid #E5E7EB",
            borderRadius: "10px", padding: "0 24px", fontSize: "14px",
            fontWeight: 500, cursor: "pointer",
            height: "44px",
            fontFamily: "'Inter','Segoe UI',sans-serif",
          }}
          onMouseEnter={e => e.currentTarget.style.background = "#F9FAFB"}
          onMouseLeave={e => e.currentTarget.style.background = "#fff"}
        >
          Cancel
        </button>
        <button
          onClick={handleUpload}
          style={{
            background: "#2563EB", color: "#fff", border: "none",
            borderRadius: "10px", padding: "0 24px", fontSize: "14px",
            fontWeight: 600, cursor: "pointer",
            height: "44px",
            fontFamily: "'Inter','Segoe UI',sans-serif",
          }}
          onMouseEnter={e => e.currentTarget.style.background = "#1D4ED8"}
          onMouseLeave={e => e.currentTarget.style.background = "#2563EB"}
        >
          Upload
        </button>
      </div>
    </div>
  );
}